import React, { Component } from 'react';
import { Button, Collapse } from 'reactstrap';

import Notification from '../../Components/Notification/Notification';
import CreateCandidateForm from '../../Components/CreateCandidateForm/CreateCandidateForm';
import Logic from '../../Logic';

class Create extends Component {
    constructor(props) {
        super(props);
        this.logic = new Logic();
        this.state = {
            candidate: this.getInitialValue(),
            isFilesUploadOpen: false,
            notificationSuccess: false,
            notificationMessage: null
        };

        this.openNotification = this.openNotification.bind(this);
        this.getInitialValue = this.getInitialValue.bind(this);
        this.onCandidateCreated = this.onCandidateCreated.bind(this);
    }

    getInitialValue() {
        //get candidate from previous page (will mostly not be available, since after creating candidate, there is no reason to go back to this page, unless changing the vendor...)
        if (this.props.location && this.props.location.state) {
            return this.props.location.state.candidate;
        }
        return { id: -1 };
    }

    async onCandidateCreated(values) {
        let res = await this.logic.createCandidate(values).then(response => {
            if (response.success) {
                this.props.onInitChanged(response.data);
                this.openNotification(response.success, response.message);
                let newCandidate = response.data.user.candidates.rows.filter(a => a.identityNumber == values.identityNumber)[0]; //the newly created candidate should be first in list
                if (newCandidate.isFillFormsByAdmin) {
                    if (window.confirm('האם תרצה למלא כעת את שאלון המועמד?')) {
                        window.open(process.env.PUBLIC_URL + 'index.html#/edit/' + newCandidate.id, '_blank');
                        this.props.history.push('/mycandidates');
                    } else {
                        this.props.history.push('/mycandidates');
                    }
                } else {
                    this.props.history.push('/mycandidates');
                }
            }
            else {this.openNotification(response.success, response.message || "אירעה שגיאה לא ידועה");}
            return response; //return resolved;
        });
        return res; //return promise
    }

    openNotification(success, message) {
        if (this.notificationTimeout) {
            clearTimeout(this.notificationTimeout);
        }

        this.setState({ notificationSuccess: success, notificationMessage: message }, () => {
            this.notificationTimeout = setTimeout(() => {
                this.setState({ notificationSuccess: false, notificationMessage: null });
                this.notificationTimeout = null;
            }, 5000);
        });
    }

    componentDidMount() {
        if (this.props.match) {
            const { authKey } = this.props.match.params;
            if (authKey) {
                this.logic.getCandidateByAuthKey(authKey, (data) => {
                    this.setState({ candidate: data });
                });
            }
        }
    }

    render() {
        return (
            <div>
                <CreateCandidateForm formTitle="יצירת מועמד חדש" candidate={this.state.candidate} onFormSubmitted={this.onCandidateCreated} init={this.props.init} />
                <Notification success={this.state.notificationSuccess} message={this.state.notificationMessage} />
            </div>
        );
    }
};

export default Create;